import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/icon/FluentIcon.module_built.css";
const classes = {"icon--attachment":"wdGN4aG_icon--attachment","fluent-icon":"wdGN4aG_fluent-icon","icon--add-document":"wdGN4aG_icon--add-document","icon--send":"wdGN4aG_icon--send","appearance--text":"wdGN4aG_appearance--text","icon--info-16":"wdGN4aG_icon--info-16","icon--keypad":"wdGN4aG_icon--keypad","icon--microphone":"wdGN4aG_icon--microphone","icon--audio-playing":"wdGN4aG_icon--audio-playing"}
export default classes

const _icon__attachment0 = classes["icon--attachment"]
export { _icon__attachment0 as "icon--attachment" }

const _fluent_icon0 = classes["fluent-icon"]
export { _fluent_icon0 as "fluent-icon" }

const _icon__add_document0 = classes["icon--add-document"]
export { _icon__add_document0 as "icon--add-document" }

const _icon__send0 = classes["icon--send"]
export { _icon__send0 as "icon--send" }

const _appearance__text0 = classes["appearance--text"]
export { _appearance__text0 as "appearance--text" }

const _icon__info_160 = classes["icon--info-16"]
export { _icon__info_160 as "icon--info-16" }

const _icon__keypad0 = classes["icon--keypad"]
export { _icon__keypad0 as "icon--keypad" }

const _icon__microphone0 = classes["icon--microphone"]
export { _icon__microphone0 as "icon--microphone" }

const _icon__audio_playing0 = classes["icon--audio-playing"]
export { _icon__audio_playing0 as "icon--audio-playing" }
